const t = ["sm", "md", "lg"], n = ["outline", "primary", "text"], o = "md", s = "outline", E = "button";
export {
  E as DEFAULT_ELEMENT_TYPE,
  o as DEFAULT_SIZE,
  s as DEFAULT_VARIANT,
  t as sizes,
  n as variants
};
